import { Theme } from '@mui/material'

const useStyles = {
  statusValue: {
    textAlign: 'right' as const,
  },
  largeText: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
  accountDetailsBox: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',
  }),
  installTypeBox: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    width: '100%',
  }),
}

export default useStyles
